import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { TextField } from "@material-ui/core"
import { obtenerAgentes } from "../../../../ducks/usuariosDuck"
import { Autocomplete } from "@material-ui/lab"
import handleRenderOption from "./handleRenderAgente"
import { onLoadAnction, offLoadAction } from "../../../../ducks/loadDuck"
import { agregarAgentesLista } from "../../../../ducks/reportesCotizacionesDuck"
const useObtenerAgentes = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(onLoadAnction({}))
        dispatch(obtenerAgentes()).then((Response) => {
            dispatch(offLoadAction())
        })
    }, [dispatch])
}
const CbAgentes = () => {
    const dispatch = useDispatch()
    const agentes = useSelector(store => store.usuarios.agentes)
    const { agentesSeleccionados } = useSelector(store => store.reporteCotizador)
    useObtenerAgentes()
    const handleSelecAgente = (event, valor) => {
        if (!valor)
            return null
        dispatch(onLoadAnction({ message: "" }))
        const newAgentesSeleccionados = [...agentesSeleccionados]
        const findAgente = newAgentesSeleccionados.findIndex(agente => agente.UserId === valor.UserId)
        if (findAgente >= 0) {
            dispatch(offLoadAction())
            return null
        }
        newAgentesSeleccionados.push(valor)
        dispatch(agregarAgentesLista({newAgentes: newAgentesSeleccionados}))
        dispatch(offLoadAction())
    }

    return (
        <Autocomplete
            id={`id-auto-Agentes`}
            options={agentes.sort((a, b) => a.Nombres > b.Nombres)}
            getOptionLabel={(option) => `${option.UserName} - ${option.Nombres}  ${option.ApellidoPaterno}  ${option.ApellidoMaterno}`}
            style={{
                width: "97%",
                margin: "5px",
                paddingBottom: "0",
                fontWeight: "500",
            }}
            disabled={agentes.length > 0 ? false : true}
            onChange={handleSelecAgente}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Agentes"
                    variant="outlined"
                    style={{ width: "100%" }}
                    name="agentes"
                />
            )}
            renderOption={handleRenderOption}
        />
    )


}
export default CbAgentes